export default "__VITE_ASSET__RCoNOVqC__"